import { MissionStatusLabel } from '@domain/labels';

export const findMissionStatusLabel = (
    missionStatusList: MissionStatusLabel[],
    missionValue: string
) => {
    return missionStatusList.find(
        missionStatus => missionStatus.value === missionValue
    );
};
